/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import httpClient from 'utils/httpClient';
import { Session } from './type';

export const RETRIEVE_SESSION_RECENTLY = (courseId: number) =>
  `/v2/courses/${courseId}/session-recently`;

export type RetrieveSessionRecentlyQuery = {
  courseId: number;
};
export type SessionRecentlyResponse = {
  session: Session;
};

export const retrieveSessionRecently = ({
  courseId,
}: RetrieveSessionRecentlyQuery) => {
  return httpClient.get<SessionRecentlyResponse>(
    RETRIEVE_SESSION_RECENTLY(courseId),
    {},
  );
};

export const useRetrieveSessionRecently = (
  { courseId }: RetrieveSessionRecentlyQuery,
  opts?: UseQueryOptions<
    AxiosResponse<SessionRecentlyResponse>,
    AxiosError<any>
  >,
) =>
  useQuery<AxiosResponse<SessionRecentlyResponse>, AxiosError<any>>(
    [RETRIEVE_SESSION_RECENTLY(courseId)],
    () => retrieveSessionRecently({ courseId }),
    { ...opts, cacheTime: 0 },
  );
